import { Injectable } from '@angular/core';

@Injectable()
export abstract class DashboardTermsMessagePopup {
    abstract OpenDashboardTermsMessagePopup(): void;
}